export default {
  tags(state) {
    return state.tagProfilazione;
  },

  tagProfilazioneObj(state) {
    return state.tagProfilazioneObj;
  },

  onlyTags(state) {
    return state.onlyTags;
  },

  tagsAvanzamento(state) {
    return state.tagsAvanzamento;
  },

  onlyTagsAvanzamento(state) {
    return state.onlyTagsAvanzamento;
  },

  tagsPersonalizzati(state) {
    return state.tagPersonalizzati;
  },

  tagsPersonalizzatiPreventivi(state) {
    return state.tagPersonalizzatiPreventivi;
  },

  onlyTagsPersonalizzati(state) {
    return state.onlyTagsPersonalizzati;
  },

  onlyTagsPersonalizzatiPreventivi(state) {
    return state.onlyTagsPersonalizzatiPreventivi;
  },
};
